const setRowGroupsOnSheet = ({ incomeStatementOrBalanceSheetData, rowGroups, setRowGroups }) => ({
  ...incomeStatementOrBalanceSheetData,
  rowGroups,
  setRowGroups,
});

export default setRowGroupsOnSheet;
